<template>
  <div class="navbar">
    <hamburger :is-active="opened" class="hamburger-container" />

    <div class="right-menu">
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <span>{{ user.name }}</span>
          <span class="user-name"> ({{ user.roleName }})</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="handlePersonalCenter">
            <i class="el-icon-user"></i> 个人中心
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { userLogout, personInfo } from "@/api/user";
import Hamburger from "@/components/Hamburger";
import { removeToken } from "@/utils/auth";

export default {
  name: "Navbar",
  components: {
    Hamburger,
  },
  data() {
    return {
      user: {},
      opened: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 请求个人信息
    getInfo() {
      personInfo().then((res) => {
        this.user = res;
      });
    },
    handlePersonalCenter() {
      // 前往个人中心
      this.$router.push("/system/user");
    },
    async logout() {
      try {
        userLogout().then(() => {
          removeToken();
          localStorage.removeItem("user_permissions");
          this.$router.push("/login");
        });
      } catch (error) {
        console.error("Logout failed:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 20px;

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    margin-right: 0;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-top: 5px;
        position: relative;

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;
          border: 2px solid #fff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .user-name {
          font-size: 14px;
          color: #606266;
          margin-right: 5px;
          font-weight: 500;
        }

        .el-icon-caret-bottom {
          font-size: 12px;
          color: #909399;
          transition: transform 0.3s;
        }

        &:hover {
          .el-icon-caret-bottom {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
}

.user-dropdown {
  .el-dropdown-menu__item {
    i {
      margin-right: 8px;
      font-size: 16px;
    }
  }
}
</style>
